const ProductListTitle = ({ name }) => (
  <span
    className="Product-name Heading leading-20 text-sm min-h-[68px] line-clamp-3 max-h-[68px]"
    data-test="PRODUCT_CARD_NAME"
  >
    {name}
  </span>
);

export default ProductListTitle;
